import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	AppBar,
	Toolbar,
	Typography,
	IconButton,
	Box,
	Menu,
	MenuItem,
	Drawer,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	CssBaseline,
	useMediaQuery,
} from "@mui/material";
import {
	AccountCircle,
	Logout,
	Home,
	People,
	Business,
	GroupAdd,
	Apartment,
	Settings,
	Menu as MenuIcon,
	PhoneAndroid,
	Link,
} from "@mui/icons-material";
import { useTheme } from "@mui/material/styles"; // importante para o sistema de breakpoints

import { getUserRole } from "../services/getUserRole";

import UserManagement from "../components/UserManagement";
import CompanyManagement from "../components/CompanyManagement";
import CustomerUserManagement from "../components/CustomerUserManagement";
import EnvironmentList from "../components/EnvironmentList";
import CompanyEnvironmentManagement from "../components/CompanyEnvironmentManagement";
import CompanyAppLinkManagement from "../components/CompanyAppLinkManagement";
import AppsManagement from "../components/AppsManagement";

const drawerWidth = 240;

const Dashboard = () => {
	const [anchorEl, setAnchorEl] = useState(null); // Menu do usuário (logout)
	const [selectedItem, setSelectedItem] = useState(""); // Item selecionado no Drawer
	const [mobileOpen, setMobileOpen] = useState(false); // Controle de abertura do Drawer no mobile

	const userRole = getUserRole();
	const token = localStorage.getItem("token");
	const navigate = useNavigate();

	// Hook para pegar o tema
	const theme = useTheme();
	// Esse hook diz se estamos em telas "md" (médio) ou maiores. Ajuste conforme sua necessidade:
	const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

	// Se o usuário for "customer", redireciona
	// useEffect(() => {
	// 	// if (userRole === "customer") {
	// 	// 	navigate("/dashboard_cliente");
	// 	// }
	// }, [userRole, navigate]);

	// Lista de itens do menu lateral
	const menuItems = [
		{
			key: "home",
			label: "Início",
			icon: <Home />,
			adminOnly: false,
		},
		{
			key: "userManagement",
			label: "Gerenciar Usuários",
			icon: <People />,
			adminOnly: false,
		},
		{
			key: "companyManagement",
			label: "Gerenciar Empresas",
			icon: <Business />,
			adminOnly: true,
		},
		{
			key: "customerUserManagement",
			label: "Usuários do Cliente",
			icon: <GroupAdd />,
			adminOnly: false,
		},
		{
			key: "environmentList",
			label: "Ambientes",
			icon: <Apartment />,
			adminOnly: false,
		},
		{
			key: "companyEnvironmentManagement",
			label: "Ambientes da Empresa",
			icon: <Settings />,
			adminOnly: true,
		},
		{
			key: 'appsManagement',
			label: 'Gerenciar Apps',
			icon: <PhoneAndroid />,
			adminOnly: true
		  },
		  {
			key: 'companyAppLink',
			label: 'Vínculo Apps',
			icon: <Link/>,
			adminOnly: false
		  }
	];

	// Filtra itens que não forem de admin, caso o userRole não seja "admin"
	const filteredMenuItems = menuItems.filter((item) => {
		// 1) itens marcados adminOnly continuam exclusivos de admin
		if (item.adminOnly && userRole !== "admin") return false;
	
		// 2) bloqueia especificamente UserManagement e CompanyAppLink para customer
		if (
		userRole === "customer" &&
		(item.key === "userManagement" || item.key === "companyAppLink")
		) {
		return false;
		}
	
		// 3) todo o resto fica visível
		return true;
	});
	

	// Lida com clique em cada item do Drawer
	const handleMenuItemClick = (itemKey) => {
		setSelectedItem(itemKey);
		// Ao clicar em um item do menu mobile, fecha o Drawer
		if (!isDesktop) {
			setMobileOpen(false);
		}
	};

	// Ao clicar no ícone hambúrguer, alterna o estado do Drawer mobile
	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	// Menu de usuário (AppBar)
	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleMenuClose = () => {
		setAnchorEl(null);
	};
	const handleLogout = () => {
		localStorage.removeItem("token");
		setTimeout(() => {
			window.location.href = "#/login";
		}, 1000);
	};

	// Renderiza o conteúdo principal conforme o item selecionado
	const renderContent = () => {
		switch (selectedItem) {
			case "home":
				return (
					<Box sx={{ flex: 1, width: '100%', height: '100vh' }}>
      <iframe
        src="https://develop.totvsnews.engpro.totvs.com.br/sigaloc/bra/por"
        title="SIGALOC"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      />
    </Box>
				);
			case "userManagement":
				return userRole === "admin" || userRole === "user" ? (
					<UserManagement token={token} role={userRole} />
				) : (
					<Typography variant="h6" sx={{ p: 2 }}>
						Você não tem permissão para acessar este recurso.
					</Typography>
				);
			case "companyManagement":
				return userRole === "admin" ? (
					<CompanyManagement token={token} />
				) : (
					<Typography variant="h6" sx={{ p: 2 }}>
						Você não tem permissão para acessar este recurso.
					</Typography>
				);
			case "customerUserManagement":
				return userRole ? (
					<CustomerUserManagement token={token} />
				) : (
					<Typography variant="h6" sx={{ p: 2 }}>
						Você não tem permissão para acessar este recurso.
					</Typography>
				);
			case "environmentList":
				return <EnvironmentList token={token} />;
			case "companyEnvironmentManagement":
				return userRole === "admin" ? (
					<CompanyEnvironmentManagement token={token} />
				) : (
					<Typography variant="h6" sx={{ p: 2 }}>
						Você não tem permissão para acessar este recurso.
					</Typography>
				);
				case 'appsManagement':
					return userRole === 'admin'
						? <AppsManagement token={token} />
						: <Typography>Sem permissão</Typography>;
					case 'companyAppLink':
					return (userRole === 'admin' || userRole === 'user')
						? <CompanyAppLinkManagement token={token} />
						: <Typography>Sem permissão</Typography>;
			default:
				return (
					<Box sx={{ flex: 1, width: '100%', height: '100vh' }}>
      <iframe
        src="https://develop.totvsnews.engpro.totvs.com.br/sigaloc/bra/por"
        title="SIGALOC"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      />
    </Box>
				);
		}
	};

	// Conteúdo do Drawer (usado tanto no modo permanente quanto temporário)
	const drawer = (
		<div>
			<Toolbar />
			<Box sx={{ overflow: "auto" }}>
				<List>
					{filteredMenuItems.map((item) => (
						<ListItem
							button
							key={item.key}
							onClick={() => handleMenuItemClick(item.key)}
							selected={selectedItem === item.key}
						>
							<ListItemIcon>{item.icon}</ListItemIcon>
							<ListItemText primary={item.label} />
						</ListItem>
					))}
				</List>
			</Box>
		</div>
	);

	return (
		<Box sx={{ display: "flex" }}>
			<CssBaseline />

			{/* AppBar no topo */}
			<AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
				<Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
					{/* Ícone hamburguer para mobile */}
					{!isDesktop && (
						<IconButton
							color="inherit"
							aria-label="open drawer"
							edge="start"
							onClick={handleDrawerToggle}
							sx={{ mr: 2 }}
						>
							<MenuIcon />
						</IconButton>
					)}

					{/* Título da aplicação */}
					<Typography variant="h6" noWrap component="div">
						Config Rental
					</Typography>

					{/* Menu do usuário */}
					<Box>
						<IconButton color="inherit" onClick={handleMenuOpen}>
							<AccountCircle />
						</IconButton>
						<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
							<MenuItem onClick={handleLogout}>
								<Logout sx={{ marginRight: 1 }} /> Sair
							</MenuItem>
						</Menu>
					</Box>
				</Toolbar>
			</AppBar>

			{/* Menu Lateral - Modo Desktop: Drawer permanente; Modo Mobile: Drawer temporário */}
			{isDesktop ? (
				<Drawer
					variant="permanent"
					sx={{
						width: drawerWidth,
						flexShrink: 0,
						[`& .MuiDrawer-paper`]: {
							width: drawerWidth,
							boxSizing: "border-box",
							marginTop: 8, // ajusta para ficar logo abaixo da AppBar
						},
					}}
					open
				>
					{drawer}
				</Drawer>
			) : (
				<Drawer
					variant="temporary"
					open={mobileOpen}
					onClose={handleDrawerToggle}
					ModalProps={{
						keepMounted: true, // melhora desempenho em dispositivos móveis
					}}
					sx={{
						[`& .MuiDrawer-paper`]: {
							width: drawerWidth,
							boxSizing: "border-box",
						},
					}}
				>
					{drawer}
				</Drawer>
			)}

			{/* Área de conteúdo, levando em conta o espaço do Drawer permanente em modo desktop */}
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					p: 3,
					marginTop: 8, // para compensar a altura da AppBar
					width: isDesktop ? `calc(100% - ${drawerWidth}px)` : "100%",
				}}
			>
				{renderContent()}
			</Box>
		</Box>
	);
};

export default Dashboard;
